var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"an-select-modal-report-selection"},[_c('r-title',[_vm._v(" Аналитика: выбор отчёта ")]),_c('ritm-tree',{attrs:{"tree-data":_vm.treeItems,"no-animations":"","no-sort":"","no-icon":"","node-click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }